// The custom-event tracking plan. Names are shared by every client, so the
// same action compares across web and mobile without a crosswalk.
//
// Conventions (formue-api docs/analytics-client-integration.md):
// - object_verb, lowercase snake_case, past tense: document_downloaded
// - the entity id goes in resourceId, which survives rollups
// - properties stay flat and small; never free text, names, amounts or
//   anything identifying

export const DOCUMENT_DOWNLOADED = 'document_downloaded';
export const PRESENTATION_EXPORTED = 'presentation_exported';
// type: tax | real_assets | quiz | passkeys | app_install | story_mode |
// annual_review | referral | referral_cta
export const PROMOTION_CLICKED = 'promotion_clicked';
export const PROMOTION_DISMISSED = 'promotion_dismissed';
// Reached the last slide of story mode.
export const STORY_MODE_COMPLETED = 'story_mode_completed';
export const SIGNING_STARTED = 'signing_started';
// type: article | podcast | webinar | event
export const FEED_ITEM_OPENED = 'feed_item_opened';
export const FACTSHEET_OPENED = 'factsheet_opened';
export const REPORT_PRINTED = 'report_printed';
export const REPORT_EXPORTED = 'report_exported';
// Here resourceId names a filter, not an entity, so per-filter numbers survive
// rollups: '<surface>' on opened, '<surface>:<filter>' on applied.
// resourceId (opened): portfolio
// resourceId (applied): portfolio:relationship | portfolio:investment_account |
// portfolio:tax_class | portfolio:external_reporting | portfolio:period
// value (period only): the period enum, never the custom dates
export const FILTER_OPENED = 'filter_opened';
export const FILTER_APPLIED = 'filter_applied';
